<template>
  <component :is="tag" v-if="tag" v-bind="properties">
    <template v-for="(child, i) in node.children">
      <ParagraphNode
        v-if="child.children.length > 0"
        :key="i"
        :node="child"
        :legalText="legalText"
        :legalTextParagraph="legalTextParagraph"
        @delete="$emit('delete', $event)"
        @editLink="$emit('editLink', $event)"
        @move="$emit('move', $event)"
        @contextMenu="$emit('contextMenu', $event)"
      />
      <ParagraphLeaf
        v-else
        :key="(child as IParagraphNode).id"
        :data-id="child.id"
        :node="child"
        :legalText="legalText"
        :legalTextParagraph="legalTextParagraph"
        @delete="$emit('delete', $event)"
        @move="$emit('move', $event)"
        @editLink="$emit('editLink', $event)"
        @contextMenu="$emit('contextMenu', $event)"
      />
    </template>
  </component>
</template>

<script lang="ts" setup>
import type { IParagraphNode } from "~/models/IParagraphNode";
import type {
  ILinkChain,
  INote,
  IParagraphEntry,
  ISchema,
} from "~/models/IUserEntry";
import type { ILegalText } from "~/models/ILegalText";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

interface Props {
  node: IParagraphNode & { entries?: IParagraphEntry[] };
  legalText: ILegalText;
  legalTextParagraph: ILegalTextParagraph;
}

const props = defineProps<Props>();

type Emits = {
  delete: [entry: IParagraphEntry];
  move: [entry: ILinkChain | INote | ISchema];
  editLink: [entry: ILinkChain];
  contextMenu: [entries: IParagraphEntry[]];
};

defineEmits<Emits>();

const { properties: _properties, tag } = useNodeTransform(props.node);

const footnote = computed(
  () =>
    tag === "a" &&
    props.legalTextParagraph.footnotes?.find(
      (footnote) => footnote.legal_text_paragraph_part_id === props.node.id
    )
);

const properties = computed(() => {
  if (footnote.value) {
    return {
      ..._properties,
      href: `#fnr${footnote.value.id}`,
      class: "text-lexmea-blue underline",
      id: `fnanchor${footnote.value.id}`,
    };
  }
  return _properties;
});
</script>
